{
  "INBOX_MGMT": {
    "HEADER": "Hộp thư đến",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Kết nối lại",
      "FACEBOOK": "Kết nối với Facebook đã hết hạn hoặc bị thu hồi. Tin nhắn gửi đến trang không đến hộp thư này và câu trả lời có thể không gửi được. Người quản lý trang Facebook phải nhấp vào Kết nối lại và đăng nhập Facebook.",
      "INSTAGRAM": "Kết nối với Instagram đã hết hạn hoặc bị thu hồi. Tin nhắn gửi đến tài khoản không đến hộp thư này và câu trả lời có thể không gửi được. Nhấp vào Kết nối lại và đăng nhập cùng tài khoản Instagram đó. Một tài khoản khác sẽ tạo hộp thư mới.",
      "GOOGLE": "Kết nối với Google đã hết hạn hoặc bị thu hồi. Email mới không đến hộp thư này và câu trả lời có thể không gửi được. Nhấp vào Kết nối lại và đăng nhập Google bằng {email}.",
      "MICROSOFT": "Kết nối với Microsoft đã hết hạn hoặc bị thu hồi. Email mới không đến hộp thư này và câu trả lời có thể không gửi được. Nhấp vào Kết nối lại và đăng nhập Microsoft bằng {email}.",
      "ALLEGRO": "Kết nối với Allegro đã hết hạn hoặc bị thu hồi. Tin nhắn từ người mua không đến hộp thư này và câu trả lời có thể không gửi được. Nhấp vào Kết nối lại và đăng nhập Allegro với tư cách người bán {seller}. Một tài khoản người bán khác sẽ tạo hộp thư mới.",
      "IMAP_LOGIN": "Máy chủ thư từ chối đăng nhập IMAP {login}. Email mới không đến được hộp thư này. Hãy kiểm tra tên đăng nhập và mật khẩu IMAP trên tab {tab} rồi lưu lại. Chúng tôi vẫn tiếp tục thử đăng nhập, và hộp thư sẽ hoạt động trở lại ngay khi đăng nhập được.",
      "WHATSAPP": "Kết nối với WhatsApp đã hết hạn hoặc bị thu hồi. Tệp đính kèm từ khách hàng không đến hộp thư này và câu trả lời có thể không gửi được. Nhấp Kết nối lại, đăng nhập Facebook và chọn lại số {phone}."
    },
    "LIST": {
      "404": "Không có hộp thư đến nào được đính kèm với tài khoản này.",
      "RECONNECT_REQUIRED": "Cần kết nối lại"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Chọn kênh",
        "BODY": "Chọn nhà cung cấp bạn muốn tích hợp với trò chuyện."
      },
      "INBOX": {
        "TITLE": "Tạo Hộp thư đến",
        "BODY": "Xác thực tài khoản của bạn và tạo hộp thư đến."
      },
      "AGENT": {
        "TITLE": "Thêm đại lý",
        "BODY": "Thêm đại lý vào hộp thư đến đã tạo."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Bạn đã sẵn sàng để đi!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Tên hộp thư đến",
        "PLACEHOLDER": "Nhập tên kênh của bạn (ví dụ: WebA)",
        "ERROR": "Vui lòng nhập tên kênh hợp lệ"
      },
      "WEBSITE_NAME": {
        "LABEL": "Tên trang web",
        "PLACEHOLDER": "Nhập tên trang web của bạn (ví dụ: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Tên nội bộ",
        "PLACEHOLDER": "Đặt tên hộp thư đến như hiển thị trên trang quản trị này",
        "ERROR": "Vui lòng nhập một tên nội bộ duy nhất"
      },
      "FB": {
        "HELP": "Tái bút: Bằng cách đăng nhập, chúng tôi chỉ có quyền truy cập vào các tin nhắn trên Trang của bạn. Chúng tôi không bao giờ có thể truy cập tin nhắn riêng tư của bạn.",
        "CHOOSE_PAGE": "Chọn trang",
        "CHOOSE_PLACEHOLDER": "Chọn một trang từ danh sách",
        "INBOX_NAME": "Tên hộp thư đến",
        "ADD_NAME": "Thêm tên cho hộp thư đến của bạn",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Chọn một giá trị",
        "CREATE_INBOX": "Tạo hộp thư đến"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Tiếp tục với Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Kết nối hồ sơ Instagram của bạn",
        "HELP": "Để thêm hồ sơ Instagram của bạn làm kênh, bạn cần xác thực Hồ sơ Instagram của mình bằng cách nhấp vào 'Tiếp tục với Instagram' ",
        "ERROR_MESSAGE": "Đã xảy ra lỗi khi kết nối đến Instagram, vui lòng thử lại",
        "ERROR_AUTH": "Đã xảy ra lỗi khi kết nối đến Instagram, vui lòng thử lại",
        "NEW_INBOX_SUGGESTION": "Tài khoản Instagram này trước đây được liên kết với một hộp thư đến khác và hiện đã được chuyển sang đây. Mọi tin nhắn mới sẽ xuất hiện tại đây. Hộp thư đến cũ sẽ không còn gửi hoặc nhận được tin nhắn cho tài khoản này nữa.",
        "DUPLICATE_INBOX_BANNER": "Tài khoản Instagram này đã được chuyển sang hộp thư đến kênh Instagram mới. Bạn sẽ không thể gửi/nhận tin nhắn Instagram từ hộp thư đến này nữa."
      },
      "TWITTER": {
        "HELP": "Để thêm hồ sơ Twitter của bạn làm kênh, bạn cần xác thực Hồ sơ Twitter của mình bằng cách nhấp vào 'Đăng nhập bằng Twitter",
        "ERROR_MESSAGE": "Đã xảy ra lỗi khi kết nối đến Twitter, vui lòng thử lại",
        "TWEETS": {
          "ENABLE": "Tạo cuộc trò chuyện từ các dòng Tweet được nhắn đến"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kênh trang web",
        "DESC": "Tạo kênh cho trang web của bạn và bắt đầu hỗ trợ khách hàng của bạn thông qua widget trang web của chúng tôi.",
        "LOADING_MESSAGE": "Tạo kênh hỗ trợ trang web",
        "CHANNEL_AVATAR": {
          "LABEL": "Hình đại diện kênh"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Vui lòng nhập một URL hợp lệ"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domain trang web",
          "PLACEHOLDER": "Nhập tên miền trang web của bạn (ví dụ: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Tiêu đề chào mừng",
          "PLACEHOLDER": "Chào bạn !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Dòng giới thiệu chào mừng",
          "PLACEHOLDER": "Chúng tôi làm cho việc kết nối với chúng tôi trở nên đơn giản. Hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Tin nhắn chúc mừng kênh",
          "PLACEHOLDER": "Acme Inc thường trả lời sau vài giờ."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Bật lời chào kênh",
          "HELP_TEXT": "Tự động gửi tin nhắn chào mừng khi có hội thoại mới.",
          "ENABLED": "Bật",
          "DISABLED": "Không bật"
        },
        "REPLY_TIME": {
          "TITLE": "Đặt thời gian phản hồi",
          "IN_A_FEW_MINUTES": "Trong một vài phút",
          "IN_A_FEW_HOURS": "Trong một vài giờ",
          "IN_A_DAY": "Trong một ngày",
          "HELP_TEXT": "Thời gian trả lời này sẽ được hiển thị trên tiện ích trò chuyện trực tiếp"
        },
        "WIDGET_COLOR": {
          "LABEL": "Màu tiện ích",
          "PLACEHOLDER": "Cập nhật màu tiện ích con được sử dụng trong tiện ích con"
        },
        "SUBMIT_BUTTON": "Tạo hộp thư đến",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể tạo kênh trang web, vui lòng thử lại"
        }
      },
      "TWILIO": {
        "TITLE": "Kênh Twilio SMS/WhatsApp",
        "DESC": "Tích hợp Twilio và bắt đầu hỗ trợ khách hàng của bạn qua SMS hoặc WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Tài khoản SID",
          "PLACEHOLDER": "Vui lòng nhập SID tài khoản Twilio của bạn",
          "ERROR": "Trường này là bắt buộc"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Trường này là bắt buộc"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Trường này là bắt buộc"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Dịch vụ nhắn tin SID",
          "PLACEHOLDER": "Vui lòng nhập SID của dịch vụ nhắn tin Twilio của bạn",
          "ERROR": "Trường này là bắt buộc",
          "USE_MESSAGING_SERVICE": "Sử dụng dịch vụ nhắn tin Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Loại kênh",
          "ERROR": "Vui lòng chọn loại kênh của bạn"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token xác thực",
          "PLACEHOLDER": "Vui lòng nhập Twilio Auth Token",
          "ERROR": "Trường này là bắt buộc"
        },
        "CHANNEL_NAME": {
          "LABEL": "Tên hộp thư đến",
          "PLACEHOLDER": "Vui lòng điền tên hộp thư đến",
          "ERROR": "Trường này là bắt buộc"
        },
        "PHONE_NUMBER": {
          "LABEL": "Số điện thoại",
          "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
          "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ bắt đầu bằng dấu `+` và không chứa bất kỳ dấu cách nào."
        },
        "API_CALLBACK": {
          "TITLE": "URL gọi lại",
          "SUBTITLE": "Bạn phải định cấu hình URL gọi lại tin nhắn trong Twilio với URL được đề cập ở đây."
        },
        "SUBMIT_BUTTON": "Tạo kênh Twilio",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể xác thực thông tin đăng nhập Twilio, vui lòng thử lại"
        }
      },
      "SMS": {
        "TITLE": "Kênh SMS",
        "DESC": "Bắt đầu hỗ trợ khách hàng thông qua SMS.",
        "PROVIDERS": {
          "LABEL": "Nhà cung cấp API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID Tài khoản",
            "PLACEHOLDER": "Vui lòng nhập ID Tài khoản Bandwidth",
            "ERROR": "Trường này là bắt buộc"
          },
          "API_KEY": {
            "LABEL": "Khoá API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Trường này là bắt buộc"
          },
          "API_SECRET": {
            "LABEL": "Bí mật API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Trường này là bắt buộc"
          },
          "APPLICATION_ID": {
            "LABEL": "ID ứng dụng",
            "PLACEHOLDER": "Vui lòng nhập ID Ứng dụng Bandwidth",
            "ERROR": "Trường này là bắt buộc"
          },
          "INBOX_NAME": {
            "LABEL": "Tên hộp thư đến",
            "PLACEHOLDER": "Vui lòng điền tên kênh",
            "ERROR": "Trường này là bắt buộc"
          },
          "PHONE_NUMBER": {
            "LABEL": "Số Điện Thoại",
            "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
            "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ bắt đầu bằng dấu `+` và không chứa bất kỳ dấu cách nào."
          },
          "SUBMIT_BUTTON": "Tạo kênh Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Chúng tôi không thể xác thực \bchứng chỉ Bandwidth, vui lòng thử lại"
          },
          "API_CALLBACK": {
            "TITLE": "URL gọi lại",
            "SUBTITLE": "Bạn phải cấu hình tin nhắn URL gọi lại trong Bandwith với URL đã được đề cập ở đây."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Tên hộp thư đến",
            "PLACEHOLDER": "Vui lòng nhập tên hộp thư đến",
            "ERROR": "Trường này là bắt buộc"
          },
          "PHONE_NUMBER": {
            "LABEL": "Số điện thoại",
            "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
            "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ, bắt đầu bằng dấu `+`."
          },
          "SUBMIT_BUTTON": "Tạo kênh SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Chúng tôi không thể tạo kênh SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Tên hộp thư đến",
            "PLACEHOLDER": "Vui lòng nhập tên hộp thư đến",
            "ERROR": "Trường này là bắt buộc"
          },
          "PHONE_NUMBER": {
            "LABEL": "Số điện thoại",
            "PLACEHOLDER": "Vui lòng nhập số điện thoại mà tin nhắn sẽ được gửi.",
            "ERROR": "Vui lòng cung cấp số điện thoại hợp lệ, bắt đầu bằng dấu `+`."
          },
          "SUBMIT_BUTTON": "Tạo kênh DIDWW",
          "API": {
            "ERROR_MESSAGE": "Chúng tôi không thể tạo kênh DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Nhà cung cấp API",
          "WHATSAPP_CLOUD": "Đám mây WhatsApp"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Bạn phải định cấu hình URL webhook và mã xác minh trong cổng Nhà phát triển của Facebook với các giá trị được hiển thị bên dưới.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Mã xác minh Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Thiết lập nhanh với Meta",
          "DESC": "Bạn sẽ được chuyển hướng đến Meta để đăng nhập vào tài khoản WhatsApp Business của mình. Có quyền quản trị viên sẽ giúp quá trình thiết lập diễn ra suôn sẻ và dễ dàng hơn.",
          "BENEFITS": {
            "EASY_SETUP": "Không cần cấu hình thủ công",
            "SECURE_AUTH": "Xác thực an toàn dựa trên OAuth",
            "AUTO_CONFIG": "Tự động cấu hình webhook và số điện thoại"
          },
          "SUBMIT_BUTTON": "Kết nối với WhatsApp Business",
          "AUTH_PROCESSING": "Đang xác thực với Meta",
          "WAITING_FOR_BUSINESS_INFO": "Vui lòng hoàn tất thiết lập doanh nghiệp trong cửa sổ Meta...",
          "PROCESSING": "Đang thiết lập tài khoản WhatsApp Business của bạn",
          "CANCELLED": "Đăng ký WhatsApp đã bị hủy",
          "WAITING_FOR_AUTH": "Đang chờ xác thực...",
          "INVALID_BUSINESS_DATA": "Dữ liệu doanh nghiệp nhận được từ Facebook không hợp lệ. Vui lòng thử lại.",
          "SIGNUP_ERROR": "Đã xảy ra lỗi đăng ký",
          "SDK_LOAD_ERROR": "Không thể tải Facebook SDK. Vui lòng thử lại.",
          "AUTH_NOT_COMPLETED": "Xác thực chưa hoàn tất. Vui lòng bắt đầu lại quy trình.",
          "SUCCESS_FALLBACK": "Tài khoản WhatsApp Business đã được cấu hình thành công",
          "RECONNECTED": "Đã kết nối lại kênh WhatsApp thành công"
        },
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Kênh API",
        "DESC": "Tích hợp với kênh API và bắt đầu hỗ trợ khách hàng của bạn.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Tạo kênh API",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh api"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Kênh Salesforce",
        "DESC": "Tích hợp với kênh Salesforce và bắt đầu hỗ trợ khách hàng của bạn.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Cấu hình URL cơ sở cho instance Salesforce của bạn.",
          "PLACEHOLDER": "URL API Salesforce"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID cho kênh Salesforce của bạn.",
          "PLACEHOLDER": "KEY ID"
        },
        "SECRET": {
          "LABEL": "Bí mật",
          "SUBTITLE": "Bí mật cho kênh Salesforce của bạn.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Tạo kênh Salesforce",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Bạn phải cấu hình webhook URL trong Salesforce với URL được đề cập ở đây."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Sử dụng bearer token này để xác thực khi cấu hình webhook trong Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Ghi đè người gửi email",
          "SUBTITLE": "Nếu được đặt, địa chỉ email này sẽ được dùng làm người gửi cho mọi email gửi đi, thay vì email nguồn của cuộc trò chuyện.",
          "PLACEHOLDER": "ví dụ: support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Kênh Allegro",
        "DESC": "Kết nối tài khoản người bán Allegro và trả lời trung tâm tin nhắn của tài khoản đó từ trung tâm liên lạc.",
        "CHANNEL_NAME": {
          "LABEL": "Tên hộp thư đến",
          "SUBTITLE": "Tên mà nhân viên nhìn thấy cho hộp thư đến này.",
          "PLACEHOLDER": "Nhập tên hộp thư đến",
          "ERROR": "Trường này là bắt buộc"
        },
        "SUBMIT_BUTTON": "Đăng nhập bằng Allegro",
        "API": {
          "ERROR_MESSAGE": "Đã xảy ra lỗi khi kết nối với Allegro, vui lòng thử lại"
        },
        "SELLER_LOGIN": {
          "TITLE": "Đăng nhập Allegro",
          "SUBTITLE": "Tài khoản người bán mà hộp thư đến này đọc và trả lời tin nhắn."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kênh Kaufland",
        "DESC": "Trả lời các tin nhắn ticket mà người mua gửi cho bạn trên sàn Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key gồm 32 ký tự trong trang cài đặt API của tài khoản người bán Kaufland của bạn.",
          "PLACEHOLDER": "khóa 32 ký tự",
          "ERROR": "Nhập Client Key gồm 32 ký tự"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key gồm 64 ký tự đi kèm với Client Key. Kaufland chỉ hiển thị một lần và không bao giờ gửi lại cho trang này.",
          "PLACEHOLDER": "khóa 64 ký tự",
          "ERROR": "Nhập Secret Key gồm 64 ký tự"
        },
        "SUBMIT_BUTTON": "Tạo Kênh Kaufland",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Đã ngắt kết nối",
          "MESSAGE": "Kaufland đã từ chối các khóa API này. Nhập lại Client Key và Secret Key để kết nối lại hộp thư đến này."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Kênh Email",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Tên kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Tạo kênh Email",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh email"
        },
        "FINISH_MESSAGE": "Bắt đầu chuyển tiếp email của bạn tới địa chỉ email sau."
      },
      "LINE_CHANNEL": {
        "TITLE": "Kênh LINE",
        "DESC": "Tích hợp với kênh LINE và bắt đầu hỗ trợ khách hàng của bạn.",
        "CHANNEL_NAME": {
          "LABEL": "Tên Kênh",
          "PLACEHOLDER": "Vui lòng nhập tên kênh",
          "ERROR": "Trường này là bắt buộc"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID Kênh LINE",
          "PLACEHOLDER": "ID Kênh LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Bí mật Kênh LINE",
          "PLACEHOLDER": "Bí mật Kênh LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token Kênh LINE",
          "PLACEHOLDER": "Token Kênh LINE"
        },
        "SUBMIT_BUTTON": "Tạo Kênh LINE",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL gọi lại",
          "SUBTITLE": "Bạn phải cấu hình webhook URL trong ứng dụng LINE với URL được nhắc đến ở đây."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Kênh Telegram",
        "DESC": "Tích hợp với kênh Telegram và bắt đầu hỗ trợ khách hàng của bạn.",
        "BOT_TOKEN": {
          "LABEL": "Token Bot",
          "SUBTITLE": "Cấu hình token bot mà bạn đã nhận được từ Telegram BotFather.",
          "PLACEHOLDER": "Token Bot"
        },
        "SUBMIT_BUTTON": "Tạo Kênh Telegram",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể lưu kênh \btelegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Cuộc gọi điện thoại",
        "DESC": "Thiết lập những cuộc gọi điện thoại sẽ hiển thị trong hộp thư đến này.",
        "NAME": {
          "LABEL": "Tên hộp thư đến",
          "SUBTITLE": "Chọn một tên dễ nhận biết."
        },
        "PHONE_NUMBER": {
          "LABEL": "Số điện thoại",
          "SUBTITLE": "Nhập số điện thoại thuộc hộp thư đến này, bạn có thể thêm số khác sau.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Tạo hộp thư đến Cuộc gọi điện thoại",
        "API": {
          "ERROR_MESSAGE": "Chúng tôi không thể tạo hộp thư đến"
        }
      },
      "AUTH": {
        "TITLE": "Chọn kênh",
        "DESC": "Trò chuyện hỗ trợ các tiện ích trò chuyện trực tiếp, Facebook Messenger, WhatsApp, Email, v. v., dưới dạng các kênh. Nếu bạn muốn xây dựng một kênh tùy chỉnh, bạn có thể tạo kênh này bằng cách sử dụng kênh API. Để bắt đầu, hãy chọn một trong các kênh bên dưới."
      },
      "AGENTS": {
        "TITLE": "Nhà Cung Cấp",
        "DESC": "Tại đây bạn có thể thêm các tác nhân để quản lý hộp thư đến mới tạo của mình. Chỉ những đại lý được chọn này mới có quyền truy cập vào hộp thư đến của bạn. Các nhân viên không thuộc hộp thư đến này sẽ không thể xem hoặc trả lời thư trong hộp thư đến này khi họ đăng nhập. <br> <b>PS:</b> Với tư cách là quản trị viên, nếu bạn cần quyền truy cập vào tất cả các hộp thư đến, bạn nên thêm mình làm đại lý cho tất cả các hộp thư đến mà bạn tạo.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Chọn đại lý cho hộp thư đến"
      },
      "DETAILS": {
        "TITLE": "Chi tiết Hộp thư đến",
        "DESC": "Từ menu thả xuống bên dưới, chọn Trang Facebook bạn muốn kết nối với trò chuyện. Bạn cũng có thể đặt tên tùy chỉnh cho hộp thư đến của mình để nhận dạng tốt hơn."
      },
      "FINISH": {
        "TITLE": "Đúng rồi!",
        "DESC": "Bạn đã tích hợp thành công Trang Facebook của mình với trò chuyện. Lần tới khi khách hàng nhắn tin cho Trang của bạn, cuộc trò chuyện sẽ tự động xuất hiện trong hộp thư đến của bạn.<br>Chúng tôi cũng đang cung cấp cho bạn tập lệnh widget mà bạn có thể dễ dàng thêm vào trang web của mình. Khi điều này xuất hiện trên trang web của bạn, khách hàng có thể nhắn tin cho bạn ngay từ trang web của bạn mà không cần sự trợ giúp của bất kỳ công cụ bên ngoài nào và cuộc trò chuyện sẽ xuất hiện ngay tại đây, trong trò chuyện.<br>Cool, huh? Well :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Xác thực bạn bằng Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Đã xảy ra sự cố, Vui lòng làm mới trang...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Chúng tôi không thể tạo hộp thư đến. Vui lòng thử lại sau.",
      "CREATING_CHANNEL": "Tạo Hộp thư đến của bạn...",
      "TITLE": "Cấu hình chi tiết hộp thư đến",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Thêm các nhà cung cấp",
      "ADD_AGENTS": "Thêm các nhà cung cấp vào hộp thư đến của bạn..."
    },
    "FINISH": {
      "TITLE": "Hộp thư đến của bạn đã sẵn sàng!",
      "MESSAGE": "Giờ đây, bạn có thể tương tác với khách hàng thông qua Kênh mới của mình. Chúc vui vẻ ủng hộ",
      "BUTTON_TEXT": "Đưa cho tôi",
      "MORE_SETTINGS": "Nhiều tuỳ chọn hơn",
      "WEBSITE_SUCCESS": "Bạn đã hoàn thành việc tạo kênh trang web thành công. Sao chép mã được hiển thị bên dưới và dán vào trang web của bạn. Lần tới khi khách hàng sử dụng cuộc trò chuyện trực tiếp, cuộc trò chuyện sẽ tự động xuất hiện trong hộp thư đến của bạn."
    },
    "REAUTH": "Ủy quyền lại",
    "VIEW": "Xem",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Đã cập nhật cài đặt hộp thư đến thành công",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Đã cập nhật thành công bài tập tự động",
        "ERROR_MESSAGE": "Chúng tôi không thể cập nhật cài đặt hộp thư. Vui lòng thử lại sau."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "từ",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Không có"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_HMAC": {
        "LABEL": "Bật"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Bật",
        "DISABLED": "Không bật"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Bật đồng bộ hóa email đến"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Bật miền email tùy chỉnh (dịch vụ trả phí)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Bật xử lý bình luận Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Chữ ký HTML",
        "SUB_TEXT": "Chữ ký này sẽ được thêm vào cuối mỗi tin nhắn gửi từ hộp thư đến này.",
        "HTML_CONTENT": "Mã HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} sẽ được thay thế bằng tên của nhân viên.\n{'{{'}email{'}}'} sẽ được thay thế bằng địa chỉ email của nhân viên đã gửi email.\n{'{{'}position{'}}'} sẽ được thay thế bằng chức vụ của nhân viên.\n{'{{'}custom_line{'}}'} sẽ được thay thế bằng dòng tùy chỉnh của nhân viên.\n{'{{'}email_signature_picture{'}}'} sẽ được thay thế bằng URL ảnh chữ ký email của nhân viên (không phải thẻ ảnh) — dùng làm nguồn ảnh (thuộc tính src của thẻ img).",
        "PREVIEW": "Xem trước"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Chữ ký theo quốc gia",
        "SUB_TEXT": "Phản hồi được ký theo quốc gia của người mua.",
        "HELP": "Phản hồi được ký theo quốc gia của cuộc hội thoại: theo gian hàng Kaufland, theo sàn của đơn hàng Allegro, hoặc nếu không có thì theo ngôn ngữ người mua viết. Khi không xác định được quốc gia hoặc quốc gia đó chưa có chữ ký tại đây, chữ ký HTML ở trên sẽ được dùng. Các sàn thương mại điện tử cấm liên kết đến website và thông tin liên hệ của bạn, vì vậy chỉ nên ghi lời chào và {'{{'}name{'}}'}.",
        "EMPTY": "Bạn chưa có chữ ký theo quốc gia nào, nên phản hồi dùng chữ ký HTML ở trên.",
        "COUNTRY": "Chọn quốc gia",
        "ADD": "Thêm chữ ký theo quốc gia",
        "REMOVE": "Xóa"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Tiền tố quay số điện thoại",
        "PLACEHOLDER": "Nhập tiền tố để định tuyến cuộc gọi đúng (ví dụ: *99)",
        "HELP_TEXT": "Tiền tố này sẽ tự động được thêm vào trước số điện thoại của liên hệ khi gọi từ hộp thư đến này."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Nội dung nút \"giải quyết sau\"",
        "PLACEHOLDER": "VD: Chúng tôi sẽ giải quyết chủ đề này qua email. Bây giờ tôi muốn hỏi về điều gì khác.",
        "HELP_TEXT": "Nhãn của nút trong widget giúp khách truy cập rời khỏi chủ đề hiện tại và hỏi về điều gì khác. Để trống để dùng văn bản mặc định theo ngôn ngữ của khách truy cập."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Tự động báo lại cuộc gọi nhỡ sau X phút",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Tự động báo lại cuộc gọi nhỡ sau số phút đã chỉ định. Để trống hoặc nhập 0 để tắt."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Tự động giải quyết cuộc gọi nhỡ sau X lần gọi lại không thành công",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Khi một cuộc gọi nhỡ đã được gọi lại X lần mà khách hàng không nghe máy, cuộc gọi đó sẽ được tự động giải quyết và một ghi chú riêng tư sẽ được thêm vào. Để trống hoặc nhập 0 để tắt."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Gợi ý câu hỏi",
        "SUB_TEXT": "Cấu hình các câu hỏi có sẵn để khách hàng dùng khi tương tác với nhân viên của bạn.",
        "QUESTIONS_LABEL": "Câu hỏi",
        "ADD_QUESTION": "Thêm câu hỏi",
        "REMOVE": "Xóa",
        "QUESTION_TEXT": "Văn bản hiển thị trong bong bóng.",
        "QUESTION_TEXT_PLACEHOLDER": "Bắt buộc",
        "QUESTION_PAYLOAD": "Văn bản được gửi khi nhấp vào.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Tùy chọn",
        "NO_BOT_MESSAGE": "Để tạo thêm gợi ý AI, vui lòng kết nối một bot.",
        "BOT_CONNECTED_MESSAGE": "Gợi ý câu hỏi AI từ bot có thể được kích hoạt trong",
        "BOT_SETTINGS_LINK": "cài đặt"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Email thay thế",
        "SUB_TEXT": "Các địa chỉ bổ sung mà hộp thư đến này nên coi là của riêng mình khi nhận thư được chuyển tiếp.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Thêm",
        "REMOVE": "Xóa",
        "EMPTY": "Chưa cấu hình email thay thế nào.",
        "HELP_TEXT": "Khi một email đến với một trong các địa chỉ này làm người nhận, các câu trả lời sẽ được gửi với cùng địa chỉ đó làm người gửi. Hãy đảm bảo máy chủ SMTP gửi đi của bạn cho phép gửi từ các địa chỉ này.",
        "SIGNATURE_LABEL": "Chữ ký",
        "PRIMARY_SIGNATURE": "Chính (mặc định)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Chữ ký bổ sung",
        "SUB_TEXT": "Xác định các chữ ký bổ sung tại đây, sau đó gán chúng cho các email thay thế bên dưới.",
        "OPTION": "Chữ ký {number}",
        "ADD": "Thêm chữ ký",
        "REMOVE": "Xóa",
        "HELP_TEXT": "Khi một phản hồi được gửi từ email thay thế, chữ ký được gán cho email đó sẽ được sử dụng thay cho chữ ký của hộp thư đến. Các email thay thế được để ở «Chính (mặc định)» sẽ dùng lại chữ ký của hộp thư đến."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Xoá",
      "AVATAR_DELETE_BUTTON_TEXT": "Xoá hình đại diện",
      "DELETE_REQUESTED_TOOLTIP": "Hộp thư đến này đã được đánh dấu để xóa",
      "RESTORE_BUTTON_TEXT": "Khôi phục",
      "CONFIRM": {
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có muốn xoá? ",
        "PLACE_HOLDER": "Vui lòng điền {inboxName} để xác nhận",
        "YES": "Có, Xoá ",
        "NO": "Không, Giữ "
      },
      "API": {
        "SUCCESS_MESSAGE": "Hộp thư đến đã được xóa thành công",
        "MARKED_FOR_DELETION_MESSAGE": "Hộp thư đến đã được đánh dấu để xóa",
        "RESTORE_SUCCESS_MESSAGE": "Đã khôi phục hộp thư đến thành công",
        "ERROR_MESSAGE": "Không thể xóa hộp thư đến. Vui lòng thử lại sau.",
        "RESTORE_ERROR_MESSAGE": "Không thể khôi phục hộp thư đến. Vui lòng thử lại sau.",
        "AVATAR_SUCCESS_MESSAGE": "Hình đại diện của hộp thư đến đã được xoá thành công",
        "AVATAR_ERROR_MESSAGE": "Không thể xoá hình đại diện của hộp thư đến. Vui lòng thử lại sau."
      }
    },
    "TABS": {
      "SETTINGS": "Cài đặt",
      "COLLABORATORS": "Cộng tác viên",
      "AUTOMATIC_PRIORITY": "Mức ưu tiên tự động",
      "AUTOMATIC_LABELING": "Gắn nhãn tự động",
      "CONFIGURATION": "Cấu hình",
      "CAMPAIGN": "Chiến dịch",
      "PRE_CHAT_FORM": "Biểu mẫu trước khi trò chuyện",
      "BUSINESS_HOURS": "Giờ làm việc",
      "WIDGET_BUILDER": "Trình tạo widget",
      "BOT_CONFIGURATION": "Cấu hình Bot",
      "SLA": "SLA"
    },
    "SETTINGS": "Cài đặt",
    "FEATURES": {
      "LABEL": "Các tính năng",
      "DISPLAY_FILE_PICKER": "Hiển thị bộ chọn tệp trên tiện ích con",
      "DISPLAY_EMOJI_PICKER": "Hiển thị bộ chọn biểu tượng cảm xúc trên tiện ích con",
      "ALLOW_END_CONVERSATION": "Cho phép người dùng kết thúc cuộc trò chuyện từ công cụ chat",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Hiển thị nút 'bắt đầu cuộc trò chuyện mới' trên đầu widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Hiển thị nút 'Chuyển đến nhân viên hỗ trợ' trên đầu widget",
      "AUTO_CLOSE_OLD": "Đánh dấu tất cả cuộc gọi trước đó từ cùng một số là đã giải quyết sau khi một cuộc gọi được giải quyết",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Tự động phân công cuộc gọi nhỡ khi thực hiện cuộc gọi đi",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Cho phép nhân viên gửi tin nhắn khi liên hệ ngoại tuyến và không có email tiếp nối"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Tập lệnh Messenger",
      "MESSENGER_SUB_HEAD": "Đặt nút này bên trong thẻ body của bạn",
      "INBOX_AGENTS": "Nhà cung cấp",
      "INBOX_TEAMS": "Nhóm",
      "INBOX_COOPERATORS": "Cộng tác viên",
      "SELECT_PLACEHOLDER": "Chọn",
      "AGENTS_OR_TEAMS_INFO": "Bạn có thể phân công nhân viên hoặc nhóm - không thể chọn cả hai cùng lúc.",
      "INBOX_AGENTS_SUB_TEXT": "Thêm hoặc xóa tác nhân khỏi hộp thư đến này",
      "AGENT_ASSIGNMENT": "Phân công cuộc trò chuyện",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Cập nhật phân công cuộc trò chuyện",
      "UPDATE": "Cập nhật",
      "ENABLE_EMAIL_COLLECT_BOX": "Bật hộp thu thập email",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Bật hoặc tắt hộp thu thập email trên cuộc trò chuyện mới",
      "AUTO_ASSIGNMENT": "Bật tự động chuyển nhượng",
      "ENABLE_CSAT": "Bật chỉ số đo lường sự hài lòng khách hàng",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Bật CSAT trên mỗi tin nhắn",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Bật / Tắt khảo sát CSAT (Mức độ hài lòng của khách hàng) sau khi giải quyết cuộc trò chuyện",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Bật / Tắt tùy chọn khảo sát CSAT cho mỗi tin nhắn do nhân viên gửi",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Bật tiếp tục cuộc trò chuyện qua email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Cuộc trò chuyện sẽ tiếp tục qua email nếu có địa chỉ email liên lạc.",
      "RESPOND_FROM_EMAIL": "Trả lời từ email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Email gửi đến khách hàng — cả trả lời và bản ghi cuộc trò chuyện — được gửi bằng cài đặt SMTP của hộp thư email đã chọn, từ địa chỉ đã chọn (địa chỉ riêng của hộp thư hoặc một trong các alias của hộp thư), và trả lời của khách hàng sẽ đến qua địa chỉ IMAP của hộp thư đó.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Bản ghi cuộc trò chuyện được gửi bằng cài đặt SMTP của hộp thư email đã chọn, từ địa chỉ đã chọn (địa chỉ riêng của hộp thư hoặc một trong các alias của hộp thư), với trả lời đến qua địa chỉ IMAP của hộp thư đó.",
      "SHOW_WELCOME_SCREEN": "Hiển thị màn hình chào mừng",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Hiển thị màn hình chào mừng khi widget được mở. Nếu tắt, widget sẽ chuyển thẳng đến màn hình cuộc trò chuyện.",
      "AUTO_CLOSE_PENDING": "Tự động giải quyết trò chuyện AI sau (giờ)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Tự động giải quyết trò chuyện AI sau X giờ không hoạt động.",
      "LOCK_TO_SINGLE_CONVERSATION": "Khóa cuộc trò chuyện duy nhất",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Bật hoặc tắt nhiều cuộc trò chuyện cho cùng một liên hệ trong hộp thư đến này",
      "INBOX_UPDATE_TITLE": "Cài đặt Hộp thư đến",
      "INBOX_UPDATE_SUB_TEXT": "Cập nhật cài đặt hộp thư đến của bạn",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Bật hoặc tắt tính năng tự động gán các cuộc hội thoại mới cho các tác nhân được thêm vào hộp thư đến này.",
      "HMAC_VERIFICATION": "Xác thực danh tính người dùng",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Xoay khóa",
        "TITLE": "Xoay khóa bí mật?",
        "WARNING": "Khóa hiện tại sẽ bị thu hồi ngay khi bạn xoay khóa.",
        "WARNING_DETAIL": "Không có thời gian chuyển tiếp và khóa không thể khôi phục được.",
        "IMPACT": "Máy chủ của bạn phải ký người dùng bằng khóa mới. Ai vẫn được ký bằng khóa cũ sẽ không vượt qua được xác thực. Nếu bắt buộc xác thực danh tính, họ sẽ không thể bắt đầu cuộc trò chuyện.",
        "CONFIRM": "Xoay khóa",
        "CANCEL": "Huỷ",
        "SUCCESS": "Khóa bí mật đã được xoay thành công",
        "ERROR": "Không thể xoay khóa bí mật, vui lòng thử lại"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Bắt buộc Xác thực danh tính người dùng",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Bắt buộc cuộc trò chuyện mới mỗi khi tải widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Nếu được bật, việc mở widget trong tab hoặc cửa sổ mới sẽ bắt đầu một cuộc trò chuyện mới.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Quên liên hệ khi bắt đầu cuộc trò chuyện mới",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Nếu tắt, cuộc trò chuyện mới được bắt đầu từ widget sẽ giữ lại liên hệ trước đó.",
      "INBOX_IDENTIFIER": "Định danh hộp thư đến",
      "INBOX_IDENTIFIER_SUB_TEXT": "Dùng token định danh hộp thư đến hiện ở đây để xác thực các ứng dụng khách API của bạn.",
      "FORWARD_EMAIL_TITLE": "Chuyển tiếp đến Email",
      "FORWARD_EMAIL_SUB_TEXT": "Bắt đầu chuyển tiếp email của bạn tới địa chỉ email sau.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Đồng bộ hóa email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Bật đồng bộ hóa và tải email đến tự động từ hộp thư đến này",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Miền email tùy chỉnh",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Bật để dùng miền email tùy chỉnh cho email gửi đi",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Bạn có thể đọc thêm tại đây.",
      "FACEBOOK_COMMENTS_TITLE": "Bình luận Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Cho phép nhắn tin sau khi cuộc trò chuyện được giải quyết",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Cho phép người dùng cuối nhắn tin sau khi cuộc trò chuyện được giải quyết.",
      "WIDGET_STATUS_LABEL": "Trạng thái widget",
      "WIDGET_STATUS_ENABLED": "Bật",
      "WIDGET_STATUS_BUSINESS_HOURS": "Bật trong giờ làm việc",
      "WIDGET_STATUS_DISABLED": "Không bật",
      "WIDGET_STATUS_HELP_TEXT": "Kiểm soát thời điểm widget hiển thị cho khách truy cập trên trang web của bạn",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Ngôn ngữ khảo sát CSAT và email",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Chọn ngôn ngữ cho tất cả email gửi khách hàng, bao gồm khảo sát CSAT, bản ghi cuộc trò chuyện và thông báo email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Kế thừa từ tài khoản",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Kết nối WhatsApp",
        "SUBTITLE": "Cách hộp thư này được kết nối với WhatsApp.",
        "PROVIDER": "Nhà cung cấp",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Đã kết nối qua đăng ký nhúng của Meta",
        "STATUS": "Trạng thái",
        "CONNECTED": "Đã kết nối",
        "RECONNECT_HINT": "Nhấn Kết nối lại trong thông báo phía trên.",
        "PHONE_NUMBER": "Số điện thoại",
        "BUSINESS_ACCOUNT": "ID tài khoản WhatsApp Business",
        "OPEN_MANAGER": "Mở trong WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID số điện thoại",
        "TEMPLATES": "Mẫu tin nhắn",
        "TEMPLATES_COUNT": "Đã duyệt {approved}/{total}",
        "TEMPLATES_SYNCED": "Đồng bộ lần cuối {date}",
        "TEMPLATES_NOT_SYNCED": "Chưa đồng bộ",
        "MANAGE_TEMPLATES": "Quản lý mẫu"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Giới hạn tự động phân công tối đa",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Xin nhập vào một số lớn hơn 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Giới hạn số cuộc trò chuyện tối đa từ hộp thư này mà có thể được tự động phân công cho một hỗ trợ viên"
    },
    "SLA": {
      "TITLE": "Chính sách SLA",
      "SUB_TEXT": "Cấu hình thời gian phản hồi và giải quyết SLA cho từng mức ưu tiên cuộc trò chuyện.",
      "LOADING": "Đang tải chính sách SLA...",
      "FIELDS": {
        "ACTIVE": "Hoạt động",
        "TICKET_PRIORITY": "Mức ưu tiên ticket",
        "FIRST_RESPONSE_TIME": "Thời gian phản hồi đầu tiên",
        "EVERY_RESPONSE_TIME": "Thời gian phản hồi mỗi lần",
        "RESOLUTION_TIME": "Thời gian giải quyết",
        "PLACEHOLDER": "ví dụ: 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Đã cập nhật chính sách SLA thành công.",
        "ERROR_MESSAGE": "Không thể cập nhật chính sách SLA. Vui lòng thử lại."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Mức ưu tiên tự động",
      "SUB_TEXT": "Cấu hình việc gán mức ưu tiên tự động dựa trên nội dung cuộc trò chuyện.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Thông báo về thanh toán",
        "MESSAGE": "Mỗi lần đánh giá mức ưu tiên sẽ phát sinh phí. Vui lòng xem chi tiết gói dịch vụ của bạn để biết thông tin giá."
      },
      "MODE": {
        "OFF": "Tắt",
        "ALL_MESSAGES": "Bật cho tất cả tin nhắn đến",
        "FIRST_MESSAGE": "Chỉ bật cho tin nhắn đến đầu tiên"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Cấu hình mức ưu tiên",
        "SUB_TEXT": "Cấu hình những mức ưu tiên nào nên được bật và mô tả của chúng. Đưa ra tiêu chí rõ ràng để AI xác định khi nào nên gán mức ưu tiên này."
      },
      "DESCRIPTION_LABEL": "Mô tả",
      "DESCRIPTION_PLACEHOLDER": "Mô tả các cuộc trò chuyện cần đánh dấu mức ưu tiên {priority}",
      "SET_AS_DEFAULT": "Đặt làm mức ưu tiên mặc định",
      "MULTIPLE_DEFAULTS_WARNING": "Chỉ nên đặt một mức ưu tiên làm mặc định. Vui lòng bỏ chọn các mức mặc định khác."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Gắn nhãn tự động",
      "SUB_TEXT": "Cấu hình việc gán nhãn tự động dựa trên nội dung cuộc trò chuyện.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Thông báo về thanh toán",
        "MESSAGE": "Mỗi lần đánh giá gắn nhãn sẽ phát sinh phí. Vui lòng xem chi tiết gói dịch vụ của bạn để biết thông tin giá."
      },
      "MODE": {
        "OFF": "Tắt",
        "CONVERSATION_OPEN": "Khi mở cuộc trò chuyện",
        "CONVERSATION_CLOSE": "Khi đóng cuộc trò chuyện",
        "ALL_MESSAGES": "Với mọi tin nhắn - bất kể trạng thái",
        "FIRST_MESSAGE": "Với tin nhắn đầu tiên - bất kể trạng thái"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Cấu hình nhãn",
        "SUB_TEXT": "Cấu hình những nhãn nào có thể được gán tự động và mô tả của chúng. Đưa ra tiêu chí rõ ràng để AI xác định khi nào nên áp dụng nhãn này."
      },
      "DESCRIPTION_LABEL": "Mô tả",
      "DESCRIPTION_PLACEHOLDER": "Mô tả các cuộc trò chuyện cần gắn nhãn {label}. Nếu để trống, mô tả của nhãn sẽ được sử dụng.",
      "NO_LABELS_MESSAGE": "Không tìm thấy nhãn nào. Hãy tạo nhãn trước để bật tính năng gắn nhãn tự động.",
      "CREATE_LABELS_LINK": "Tạo nhãn"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ủy quyền lại",
      "SUBTITLE": "Kết nối Facebook của bạn đã hết hạn, vui lòng kết nối lại trang Facebook của bạn để tiếp tục dịch vụ",
      "MESSAGE_SUCCESS": "Kết nối lại thành công",
      "MESSAGE_ERROR": "Đã có lỗi, vui lòng thử lại"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Biểu mẫu trước khi trò chuyện cho phép bạn nắm bắt thông tin người dùng trước khi họ bắt đầu cuộc trò chuyện với bạn.",
      "SET_FIELDS": "Những ô cần điền vào trước cuộc trò chuyện",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Ô cần điền",
        "LABEL": "Nhãn",
        "PLACE_HOLDER": "Cụm từ hiện nền trong ô",
        "KEY": "Khoá",
        "TYPE": "Kiểu",
        "REQUIRED": "Bắt buộc"
      },
      "ENABLE": {
        "LABEL": "Bật biểu mẫu trước khi trò chuyện",
        "OPTIONS": {
          "ENABLED": "Có",
          "DISABLED": "Không"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Tin nhắn trước khi trò chuyện",
        "PLACEHOLDER": "Tin nhắn này sẽ hiện cho những người dùng cùng với biểu mẫu"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Khách truy cập nên cung cấp tên và địa chỉ email của họ trước khi bắt đầu trò chuyện"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Đặt tính khả dụng của bạn",
      "SUBTITLE": "Đặt tính khả dụng của bạn trên tiện ích trò chuyện trực tiếp",
      "WEEKLY_TITLE": "Đặt giờ hàng tuần của bạn",
      "TIMEZONE_LABEL": "Chọn múi giờ",
      "UPDATE": "Cập nhật tuỳ chỉnh giờ làm việc",
      "TOGGLE_AVAILABILITY": "Kích hoạt tính khả dụng của doanh nghiệp cho hộp thư đến này",
      "UNAVAILABLE_MESSAGE_LABEL": "Thông báo không có sẵn cho khách truy cập",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Kích hoạt tính khả dụng cho hôm nay",
        "UNAVAILABLE": "Không có sẵn",
        "HOURS": "giờ",
        "VALIDATION_ERROR": "Giờ bắt đầu nên trước giờ đóng cửa.",
        "CHOOSE": "Chọn"
      },
      "ALL_DAY": "Cả ngày",
      "SAVE_TO_ALL": "Lưu cho tất cả hộp thư đến",
      "SAVE_TO_ALL_TITLE": "Sao chép giờ làm việc",
      "SAVE_TO_ALL_CONFIRM": "Cài đặt trong biểu mẫu này (bật/tắt tính khả dụng, thông báo vắng mặt, múi giờ và giờ làm việc) sẽ được sao chép sang tất cả hộp thư đến khác, trừ hộp thư đến email và điện thoại. Bạn có chắc chắn muốn tiếp tục không?",
      "SAVE_TO_ALL_CANCEL": "Huỷ",
      "SAVE_TO_ALL_YES": "Có, sao chép cho tất cả",
      "SAVE_TO_ALL_SUCCESS": "Đã sao chép giờ làm việc sang tất cả hộp thư đến khác thành công",
      "SAVE_TO_ALL_ERROR": "Không thể sao chép giờ làm việc sang các hộp thư đến khác"
    },
    "PHONE": {
      "TITLE": "Cài đặt điện thoại",
      "SUBTITLE": "Cấu hình những cuộc gọi sẽ hiển thị trong hộp thư đến này.",
      "UPDATE": "Lưu cài đặt",
      "EDIT": {
        "SUCCESS_MESSAGE": "Đã cập nhật cài đặt điện thoại"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Số điện thoại",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Đặt chi tiết IMAP",
      "NOTE_TEXT": "Để bật chế độ SMTP, xin hãy cấu hình IMAP.",
      "UPDATE": "Cập nhật chi tiết IMAP",
      "TOGGLE_AVAILABILITY": "Kích hoạt cấu hình IMAP cho hộp thư đến này",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Tuỳ chỉnh IMAP được cập nhật thành công",
        "ERROR_MESSAGE": "Không thể cập nhật tuỳ chỉnh IMAP"
      },
      "ADDRESS": {
        "LABEL": "Địa chỉ",
        "PLACE_HOLDER": "Địa chỉ (Ví dụ: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Đăng nhập",
        "PLACE_HOLDER": "Đăng nhập"
      },
      "PASSWORD": {
        "LABEL": "Mật khẩu",
        "PLACE_HOLDER": "Mật khẩu"
      },
      "ENABLE_SSL": "Kích hoạt SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "STMP",
      "SUBTITLE": "Đặt chi tiết SMTP",
      "UPDATE": "Cập nhật tuỳ chỉnh SMTP",
      "TOGGLE_AVAILABILITY": "Kích hoạt cấu hình SMTP cho hộp thư đến này",
      "TOGGLE_HELP": "Kích hoạt SMTP sẽ giúp cho người dùng gửi email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Tuỳ chỉnh SMTP được cập nhật thành công",
        "ERROR_MESSAGE": "Không thể cập nhật tuỳ chỉnh SMTP"
      },
      "ADDRESS": {
        "LABEL": "Địa chỉ",
        "PLACE_HOLDER": "Địa chỉ (Ví dụ: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Đăng nhập",
        "PLACE_HOLDER": "Đăng nhập"
      },
      "PASSWORD": {
        "LABEL": "Mật khẩu",
        "PLACE_HOLDER": "Mật khẩu"
      },
      "DOMAIN": {
        "LABEL": "Miền",
        "PLACE_HOLDER": "Miền"
      },
      "ENCRYPTION": "Mã hoá",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Mở Chế độ xác minh SSL",
      "AUTH_MECHANISM": "Xác minh"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Khả năng gửi email thành công (DNS)",
      "SUB_TITLE": "Chúng tôi kiểm tra các bản ghi SPF, DKIM, DMARC và MX của {domain} vào mỗi ngày làm việc. Khi có điều gì khiến máy chủ nhận thư từ chối hoặc đưa thư trả lời của quý khách vào thư rác, quản trị viên sẽ nhận được email kèm cách khắc phục.",
      "RUN": "Chạy kiểm tra",
      "RUN_SUCCESS": "Đã kiểm tra DNS xong",
      "RUN_ERROR": "Không thể chạy kiểm tra DNS, vui lòng thử lại",
      "NOT_CHECKED": "Chưa được kiểm tra.",
      "CHECKED_AT": "Kiểm tra lần cuối {time}.",
      "DNS_UNAVAILABLE": "Lần kiểm tra gần nhất không nhận được phản hồi từ máy chủ tên miền. Kết quả bên dưới là của lần kiểm tra trước đó.",
      "SENDER": {
        "SMTP": "Thư trả lời được gửi qua {host}.",
        "PLATFORM": "Thư trả lời được gửi qua máy chủ thư của chúng tôi."
      },
      "STATUS": {
        "OK": "Tất cả bản ghi đều ổn",
        "WARNING": "Một số bản ghi có thể tốt hơn",
        "ERROR": "Thư trả lời có thể không đến được người nhận",
        "UNKNOWN": "Không xác định"
      },
      "SEVERITY": {
        "ERROR": "Sự cố",
        "WARNING": "Cảnh báo"
      },
      "FIX": "Hãy khắc phục bằng bản ghi DNS sau:",
      "RECORD_TYPE": "Loại",
      "RECORD_HOST": "Tên",
      "RECORD_VALUE": "Giá trị",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Thiếu bản ghi SPF",
          "DESCRIPTION": "Tên miền chưa cho biết máy chủ nào được phép gửi email của nó. Nhiều máy chủ thư khi đó sẽ coi thư trả lời của quý khách là thư rác. Hãy thêm bản ghi SPF cho phép {sender}."
        },
        "spf_multiple": {
          "TITLE": "Tên miền có {count} bản ghi SPF",
          "DESCRIPTION": "Một tên miền chỉ được có một bản ghi SPF. Nếu có nhiều hơn, máy chủ nhận thư sẽ bỏ qua SPF và thường từ chối thư. Hãy gộp chúng thành một bản ghi."
        },
        "spf_not_authorized": {
          "TITLE": "SPF không cho phép máy chủ gửi thư trả lời của quý khách",
          "DESCRIPTION": "Thư trả lời của quý khách được gửi qua {sender}, nhưng bản ghi SPF của tên miền không liệt kê máy chủ này. Bản ghi hiện tại: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Bản ghi SPF cần quá nhiều lượt tra cứu DNS",
          "DESCRIPTION": "Máy chủ nhận thư ngừng kiểm tra SPF sau {limit} lượt tra cứu DNS, nhưng {sender}, máy chủ gửi thư trả lời của quý khách, chỉ được xét đến sau {lookups} lượt. Thư trả lời của quý khách không đạt SPF. Hãy chuyển {sender} lên đầu bản ghi và xóa các include mà tên miền không còn dùng."
        },
        "spf_lookups_others": {
          "TITLE": "Một số bên gửi trong bản ghi SPF nằm ngoài giới hạn tra cứu",
          "DESCRIPTION": "Bản ghi SPF cần {lookups} lượt tra cứu DNS, còn máy chủ nhận thư dừng lại sau {limit}. Thư trả lời của quý khách được khớp kịp thời nên đạt SPF, nhưng thư từ các bên gửi sau không đạt SPF: {senders}. Hãy xóa các include mà tên miền không còn dùng."
        },
        "spf_malformed": {
          "TITLE": "Bản ghi SPF bị lỗi",
          "DESCRIPTION": "Máy chủ nhận thư không đọc được bản ghi SPF của tên miền nên bản ghi không bảo vệ được thư trả lời của quý khách. Lỗi nằm ở: {terms}. Hãy thay bản ghi bằng bản đã sửa."
        },
        "dkim_missing": {
          "TITLE": "Chưa thiết lập chữ ký DKIM",
          "DESCRIPTION": "Chúng tôi không tìm thấy khóa DKIM tại {selectors}. Nếu không có, thư trả lời của quý khách sẽ không được ký và dễ bị vào thư rác hơn. Hãy bật ký DKIM cho tên miền tại nhà cung cấp email của quý khách."
        },
        "dmarc_missing": {
          "TITLE": "Thiếu bản ghi DMARC",
          "DESCRIPTION": "Các nhà cung cấp email lớn như Gmail và Microsoft yêu cầu có bản ghi DMARC. Nếu không có, thư trả lời của quý khách dễ bị vào thư rác hơn."
        },
        "dmarc_fails": {
          "TITLE": "DMARC yêu cầu bên nhận từ chối thư trả lời của quý khách",
          "DESCRIPTION": "Chính sách DMARC của tên miền là “{policy}” và thư trả lời của quý khách không đạt cả SPF lẫn DKIM, nên bên nhận từ chối thư hoặc chuyển vào thư rác. Hãy sửa SPF và DKIM ở trên."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC chặn thư trả lời gửi qua máy chủ thư của chúng tôi",
          "DESCRIPTION": "Hộp thư này gửi thư trả lời qua máy chủ thư của chúng tôi, nhưng chính sách DMARC của tên miền là “{policy}”, nên bên nhận từ chối thư hoặc chuyển vào thư rác. Hãy thiết lập SMTP của máy chủ thư riêng cho hộp thư này."
        },
        "mx_missing": {
          "TITLE": "Tên miền không có bản ghi MX",
          "DESCRIPTION": "Nếu không có bản ghi MX, không ai có thể gửi email đến tên miền này, nên khách hàng không thể trả lời thư của quý khách."
        }
      }
    },
    "NOTE": "Ghi chú: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Hình đại diện trang web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Hình đại diện đã được xóa thành công",
              "ERROR_MESSAGE": "Đã có lỗi, vui lòng thử lại"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Tên trang web",
          "PLACE_HOLDER": "Nhập tên trang web của bạn (ví dụ: Acme Inc)",
          "ERROR": "Vui lòng nhập tên trang web hợp lệ"
        },
        "WELCOME_HEADING": {
          "LABEL": "Tiêu đề chào mừng",
          "PLACE_HOLDER": "Chào bạn!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Dòng giới thiệu chào mừng",
          "PLACE_HOLDER": "Chúng tôi làm cho việc kết nối với chúng tôi trở nên đơn giản. Hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn."
        },
        "REPLY_TIME": {
          "LABEL": "Thời gian trả lời",
          "IN_A_FEW_MINUTES": "Trong một vài phút",
          "IN_A_FEW_HOURS": "Trong một vài giờ",
          "IN_A_DAY": "Trong một ngày"
        },
        "WIDGET_COLOR_LABEL": "Màu tiện ích",
        "WIDGET_BUBBLE_POSITION_LABEL": "Vị trí bong bóng widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Chiều cao tối đa của tin nhắn chưa đọc (px)",
          "PLACE_HOLDER": "Không giới hạn",
          "HELP_TEXT": "Giới hạn chiều cao tối đa của cửa sổ tin nhắn chưa đọc theo pixel. Để trống để dùng hành vi mặc định (không giới hạn)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Kiểu bong bóng widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Trò chuyện với chúng tôi",
          "LABEL": "Tiêu đề trình khởi chạy bong bóng widget",
          "PLACE_HOLDER": "Trò chuyện với chúng tôi"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Cập nhật cài đặt widget",
          "API": {
            "SUCCESS_MESSAGE": "Đã cập nhật cài đặt widget thành công",
            "ERROR_MESSAGE": "Không thể cập nhật cài đặt widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Xem trước",
          "SCRIPT": "Kịch bản"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Trái",
          "RIGHT": "Phải"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Chuẩn",
          "EXPANDED_BUBBLE": "Mở rộng bong bóng"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Mặc định",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Thường trả lời sau vài phút",
        "IN_A_FEW_HOURS": "Thường trả lời sau vài giờ",
        "IN_A_DAY": "Thường trả lời trong một ngày"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Bắt đầu một cuộc trò chuyện",
        "CHAT_INPUT_PLACEHOLDER": "Gõ tin nhắn của bạn"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Chúng tôi đang trực tuyến",
          "OFFLINE": "Hiện tại chúng tôi đang bận chút"
        },
        "USER_MESSAGE": "Xin chào",
        "AGENT_MESSAGE": "Xin chào"
      },
      "BRANDING_TEXT": "CC bởi JARABOT",
      "SCRIPT_SETTINGS": "\nwindow.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Trang web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Kênh API",
      "PHONE": "Điện thoại SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
